// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2rLu7","footer":"ModalFilter_footer__3q1Gt"};